import axios from 'axios';
import { attachAcceptLanguage } from '../interceptors/attach-accept-language';
import { attachAccessToken } from '../interceptors/attach-access-token';
import { attachDirectoryToken } from '../interceptors/attach-directory-token';

const authApi = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/authentication-user/v1`,
});

authApi.interceptors.request.use(attachAccessToken);
authApi.interceptors.request.use(attachDirectoryToken);
authApi.interceptors.request.use(attachAcceptLanguage);

export default authApi;
